import { User } from '../../models/User';
import { CAUserState, USER_MUTATION_SET_USER } from './index.types';

declare var window: any; // Fix compilación (ToDo eliminar)

const state = {
  user: null
};

const getters = {
  user: (state: any) => {
    return state.user;
  }
};

const mutations = {
  /**
	 * Actualización de usuario. 
	 * Invocado desde login al presionar botón Iniciar Sesión y desde header al clickear Cerrar Sesión.
	 * 
	 * 
	 * @param state 
	 * @param user 
	 */
  [USER_MUTATION_SET_USER](state: CAUserState, user: User) {
    state.user = user;
  }
};

export default {
  state,
  getters,
  mutations
};